import React from "react";
import { Form, Input, Row, Col } from "antd";
import { WifiOutlined } from "@ant-design/icons";

import Button from "../../../shared/globalStyling/Button";

const CreateAmplifyForm = ({
  handleAmplifyCampaign,
  enableAmplify,
  currentAmplifyCampaign,
}) => {
  const [form] = Form.useForm();

  const onFinish = values => {
    form.resetFields();
    handleAmplifyCampaign(values);
  };

  return (
    <Form
      form={form}
      name="basic"
      initialValues={{
        clickthrough: currentAmplifyCampaign
          ? currentAmplifyCampaign.adUnits[0].clickthrough
          : "",
      }}
      onFinish={onFinish}
      autoComplete="off"
    >
      <Row>
        <Col xs={24} md={24} lg={6}>
          <Form.Item
            name="clickthrough"
            rules={[
              {
                type: "url",
                required: true,
                message:
                  'Please add "http://" or "https://" for example "http://www.example.com"',
              },
            ]}
          >
            <Input
              style={{
                width: "95%",
                margin: "10px 0 10px 0",
                height: "38px",
              }}
              value=""
              placeholder="Click-Through Link"
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={24} lg={6}>
          <Button
            type="primary"
            htmlType="submit"
            icon={<WifiOutlined rotate="90" />}
            disabled={!enableAmplify}
          >
            Amplify
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default CreateAmplifyForm;
